import React from 'react';
import './static/font/stylesheet.css';

import { NotificationStore } from './src/store/notification/store';

// eslint-disable-next-line
export const wrapRootElement = ({ element }) => <NotificationStore>{element}</NotificationStore>;
